import { AxiosService } from './axios.service'

/**
 * Defines the API methods to integrate with blockchain
 */
export class BlockchainService {
	static baseURL = 'blockchain'

	/**
	 * Gets the balance points of an user
	 * @param {integer} moveflexNumber The moveflex number
	 * @return {Promise<long>} The balance points
	 */
	static getPoints(moveflexNumber) {
		return AxiosService.get(
			`${this.baseURL}/saldo-de-pontos/${moveflexNumber}`
		).then(({ data }) => data)
	}

	/**
	 * Move points between users
	 * @param {Object}
	 * @param {integer} securityNumber securityNumber
	 * @param {integer} destinationMoveflexNumber
	 * moveflexNumber of the user that will receive points
	 * @param {integer} sourceMoveflexNumber
	 * moveflexNumber of the user sending points
	 * @param {integer} value
	 * quantity of points
	 * @param {string} notes
	 * Complementary information
	 * @param {string} destinationName
	 */
	static movePoints(data) {
		return AxiosService.post(`${this.baseURL}/mover-pontos`, data).then(
			({ data }) => data
		)
	}
}
